import { Box, Grid } from "@material-ui/core";
import DropdownFilter from "components/DropdownFilter";
import { uniqBy } from "lodash";
import { arrayToObject } from "utils/object-util";
import { addLegStyle } from "../AddLoadLeg/style";

export const LoadAssetSelector = ({
  loadGroup,
  setSelectedAsset,
  selectedValue,
  isNewLoad,
  allowNewAsset,
}) => {
  const classes = addLegStyle();

  const rawAssets = isNewLoad
    ? (loadGroup?.loads || []).flatMap((l) => l.assets || [])
    : (loadGroup?.loads || [])
        .filter((l) => Array.isArray(l.assets) && l.assets.length)
        .flatMap((l) => l.assets);

  let assets = uniqBy(
    (rawAssets || [])
      .filter((a) => typeof a?.vin === "string" && a.vin.trim().length > 0)
      .map((a) => ({
        ...a,
        id: isNewLoad? a.vin.trim(): a.id, 
      })),
    "id"
  );

  if (allowNewAsset) {
    assets.unshift({ id: "__new__", name: "" });
  }

  const assetLookup = arrayToObject(assets);

  return (
    <DropdownFilter
      value={selectedValue}
      title={"Select asset"}
      values={assets}
      renderOption={(option) => (
        <Box className={classes.option}>
          <Grid item xs={12} container direction="column">
            {option?.id === "__new__" ? (
              <Grid item>New Asset</Grid>
            ) : (
              <>
                <Grid item>
                  <b>VIN:</b> {option?.vin}
                </Grid>

                {!!option?.assetId && (
                  <Grid item>
                    <b>Asset ID:</b> {option?.assetId}
                  </Grid>
                )}

                {(option?.year || option?.make || option?.model) && (
                  <Grid item>
                    {option?.year ?? ""} {option?.make ?? ""} {option?.model ?? ""}
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </Box>
      )}
      onSelect={(id) => {
        if (id === "__new__") {
          setSelectedAsset(null);
          return;
        }
        setSelectedAsset(assetLookup?.[id]);
      }}
    />
  );
};
